<template>
  <div class="card">
    <div v-if="!isLoaded" class="content">
      <placeholder-content isLoad="true" />
    </div>
    <div v-if="isLoaded" class="card-header  border-bottom my-0">
      <h5 class="card-title text-uppercase">{{$t('_reports.Period of total sales')}}</h5>
    </div>
    <div class="card-body">
      <v-chart v-if="isLoaded" class="chart" :option="option" autoresize/>
      <div class="no-data" v-if="hasData">
        <span>
          <h3>{{ $t("No Data to Display") }}</h3>
        </span>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import {
      use
  } from "echarts/core";
  import {
      CanvasRenderer
  } from "echarts/renderers";
  import {
      BarChart
  } from "echarts/charts";
  import {
      graphic
  } from "echarts";
  import {
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      GridComponent,
      ToolboxComponent,
  } from "echarts/components";
  import VChart, {
      THEME_KEY
  } from "@/plugins/vue-echarts";
  import moment from "moment";
  
  import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
  use([
      CanvasRenderer,
      TitleComponent,
      TooltipComponent,
      LegendComponent,
      GridComponent,
      ToolboxComponent,
      BarChart,
  ]);
  import {
      localSave,
      localRead
  } from "@/store/lang";
  import numeral from "numeral";
  export default {
      components: {
          VChart,
          PlaceholderContent
      },
      provide: {
          [THEME_KEY]: "default",
      },
      props: {
        chartLineColumns: {
          type: Array,
          default() {
            return [];
          }
        },
        yAxisText: {
          type: String,
          default() {
            return this.$t('_Shipping.Number of Orders');
          }
        }
      },
      data() {
          let vm = this;
          return {
              lang: localRead("local"),
              hasData: false,
              option: {
                  textStyle: {
                      fontFamily: 'Sarabun',
                  },
                  tooltip: {
                      trigger: "axis",
                      textStyle: {
                          fontSize: 14,
                      },
                      axisPointer: {
                          type: "shadow",
                      },
                      formatter : function (params) {
                      var tempData = [];
                      let txt = '';
                      txt += '<div class="mb-1 pl-2 pr-5">';
                          for (let param of params) {
                              // console.log('param.data' ,param.data)
                              txt += vm.$t(param.data[4]) +" "+ param.data[3];
                              txt += '<div>';
                                  txt += '<h4 class="mt-1"><b>' + param.data[5]  + '</b></h4>';
                                  txt += '<span>';
                                      txt += '<span class="row">';
                                          txt += '<span class="col-sm-7">';
                                          txt += vm.$t("_Shipping.Number of Orders");
                                          txt += '<br>';
                                          txt += vm.$t("Sales");
                                          txt += '</span>';
  
                                          txt += '<span class="col-sm-5">'
                                          txt += ' ' + numeral(param.data[2]).format("0,0");
                                          txt += '<br>';
                                          txt += ' ฿' + numeral(param.data[1]).format("0,0.00") ;
                                          txt += '</span>';
                                      txt += '</span>';
                                  txt += '</span>';
                              txt += '</div>';
                          }
                          return  txt;
                      },
                  },
                  grid: {
                      top: 45,
                      bottom: 0,
                      left: 10,
                      right: 5,
                      containLabel: true,
                  },
                  xAxis: [{
                      type: "category",
                      data: [0,1,2,3,4,5,6,7,8,9],
                      boundaryGap:false,
                      axisLabel: {
                          formatter: (function(value) {
                              return moment(value).utc().format('HH:mm');
                          })
                      },
                      axisTick: {
                          alignWithLabel: true,
                      },
                  }, ],
                  yAxis: {
                      name: this.$t("Sales"),
                      type: "value",
                      nameTextStyle: {
                          align: "left",
                          padding: [0, 0, 5, -25],
                          fontSize: 13,
                      },
                      splitLine: {
                          lineStyle: {
                              type: "dashed"
                          }
                      },
                      axisLabel: {
                          formatter: function (value, index) {
                              var sales = value / 1000;
                              return sales + 'k';
                          }
                      }
                  },
                  legend: {
                      left: "right",
                      itemHeight: 10,
                      itemWidth: 10,
                  },
                  series: {
                      data: [0],
                      type: 'line',
                      smooth: true,
                      barMaxWidth: 75,
                      barWidth: "80%",
                      barGap: "20%",
                      areaStyle: {
                          color: new graphic.LinearGradient(0, 0, 0, 1, [
                              {
                                  offset: 0,
                                  color: 'rgba(58,100,300,0.3)'
                              },
                              {
                                  offset: 1,
                                  color: 'rgba(255,255,255,0)'
                              }
                          ])
                      },
                  },
              },
              isLoaded: false,
              chartLineData: [],
          };
      },
      async mounted() {
        if (this.chartLineColumns.length > 0) {
          this.chartLineData = this.chartLineColumns;
          this.chartLineData = _.orderBy(this.chartLineData, [5], ["asc", "desc"]);
          this.option.xAxis[0].data = undefined;
          this.option.yAxis.type = "value"
          this.option.series = [{
            data: this.chartLineData,
            type: 'line',
            smooth: true,
            barMaxWidth: 75,
            barWidth: "80%",
            barGap: "20%",
            areaStyle: {
              color: new graphic.LinearGradient(0, 0, 0, 1, [
                {
                    offset: 0,
                    color: 'rgba(58,100,300,0.3)'
                },
                {
                    offset: 1,
                    color: 'rgba(255,255,255,0)'
                }
              ])
            },
          }]
          this.isLoaded = true;
          this.hasData = false;
        }else{
          this.isLoaded = true;
          this.hasData = true;
        }
      },
      methods: {
      },
      watch: {
      }
  };
  </script>
  
  <style scoped>
  .chart {
      height: 370px;
  }
  .no-data {
      position: absolute;
      opacity: 0.25;
      height: 100%;
      width: 100%;
      top: 0;
  }
  .no-data span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 1.5em;
      white-space: nowrap;
      text-align: center;
  }
  </style>


// WEBPACK FOOTER //
// src/components/tenancy/admin/report/SalesOrder/saledaily/SaledailyLineChart.vue